export default __webpack_public_path__ + "static/media/hp.81c86f1b.svg";